import { useModalPromise } from '@cp/shared/modal';
import { useCallback } from 'react';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { ORDER_NANNY_MODAL, SUCCESS_ORDER_MODAL } from '../../lib';

export const useOrderNannyModals = () => {
  const orderNanny = useModalPromise(ORDER_NANNY_MODAL);
  const successOrder = useModalPromise(SUCCESS_ORDER_MODAL);

  return useCallback(
    async (catalogItem: CatalogItemViewModel, dialogId: number, initiatorId?: number) => {
      const deal = await orderNanny({
        dialogId,
        catalogItem,
        initiatorId,
      });
      successOrder({ deal });
    },
    [orderNanny, successOrder],
  );
};
